const CONFIGURATOR_TYPES = {
    CATALOG_CONFIGURATOR: 'catalog_configurator',
    REGO_LOOKUP: 'rego_lookup',
    VEHICLE_CONFIGURATOR: 'vehicle_configurator',
};

export default CONFIGURATOR_TYPES;
